import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { GridOptions } from "ag-grid";

import {
  EligibilitySummary,
  CommonUtility,
  EligibilitySummaryRequest,
  EligSummary,
  DOUBLE_ROW_HEADER, AgGridUtility, WpEtEnrollment
} from '../shared';

import { DateUtility, ServerConstantsService } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { DataService } from '../shared';
import { NotificationsService } from 'angular2-notifications';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-eligibility-summary',
  templateUrl: './eligibility-summary.component.html',
  styleUrls: ['./eligibility-summary.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class EligibilitySummaryComponent implements OnInit {


  response: EligibilitySummary;
  request: EligibilitySummaryRequest;
  eligSummaryList: EligSummary[];
  programArray: any[];
  programMap: any;

  countyArray: any[];
  countyMap: any;

  ServerConstants: any;
  userActionNotificationsMap: any;
  refData: any;


  successMessage: string;
  errorMessage: string;
  sharedData: any;
  DOUBLE_ROW_HEADER = DOUBLE_ROW_HEADER;
  columnDefs: any;
  context: any;
  programJson: any;
  countyJson: any;
  etEnrollment: WpEtEnrollment;
  gridOptions: GridOptions;
  gridApi;
  ssnValue;
  isUniverse;
  firstTime: Boolean = true;

  @ViewChild('header') header: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private dateUtil: DateUtility,
    private agGridUtility: AgGridUtility,
    private datePipe:DatePipe
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
  }

  ngOnInit() {
    this.dataService.globalAccess = false;
    if(this.dataService.globalAccess == undefined){
      this.router.navigate(['/task']);
    }
    this.parseRefTableData();
    this.getColumnDefinitions();

    /* set global values for page */
    this.sharedData = this.dataService.getSharedDataObject();
    this.ssnValue = this.sharedData.get('SSN_SEARCH');
    this.isUniverse = this.sharedData.get('UNIVERSE_SEARCH');
    (this.sharedData.get('personProvider').conversionStat === 'CM') ? this.loadFromAries(this.sharedData.get('personProvider').emciId) : this.load();
  }

  getColumnDefinitions() {
    this.context = {
      component: this,
    };

    this.columnDefs = [
      {
        headerName: 'Program Type',
        field: 'PROGRAM_CD',
        cellStyle: { 'white-space': 'normal' },
       // valueGetter: this.getProgramDesc,
      },
      {
        headerName: 'ABA Months',
        field: 'ABA_MONTHS',
        cellStyle: { 'white-space': 'normal' },
      },
      {
        headerName: 'Certification Period Dates',
        colId: 'certBeginDt&certEndDt',
        cellStyle: { 'white-space': 'normal' },
       valueGetter: this.getCertPeriodDates,
      },
      {
        headerName: 'Benefit Amount',
        field: 'BENEFIT_AMT',
        cellStyle: { 'white-space': 'normal' },
        valueFormatter: this.agGridUtility.formatAmount,
      },
      {
        headerName: 'Service County',
        field: 'COUNTY',
        cellStyle: { 'white-space': 'normal' },
      },
    ];
  }



  getCertPeriodDates(params) {
    const eligSummary: EligSummary = params.data;
    const that = params.context.component;
    let certBeg = '';
    let certEnd = '';
    let datesStr;

    if (eligSummary.CERT_BEGIN_DT != null) {
      certBeg = that.agGridUtility.formatDateValue(eligSummary.CERT_BEGIN_DT);
    }

    if (eligSummary.CERT_END_DT != null) {
      certEnd = that.agGridUtility.formatDateValue(eligSummary.CERT_END_DT);
    }

    datesStr = certBeg + ' - ' + certEnd;
    return datesStr;
  }

  getProgramDesc(params) {
    const eligSummary: EligSummary = params.data;
    const that = params.context.component;

    if (eligSummary.PROGRAM_CD === null || eligSummary.PROGRAM_CD === undefined) {
      return '';
    } else {
      return that.programMap.get(eligSummary.PROGRAM_CD);
    }
  }

  getCountyDesc(params) {
    const eligSummary: EligSummary = params.data;
    const that = params.context.component;

    if (eligSummary.COUNTY === null || eligSummary.COUNTY === undefined) {
      return '';
    } else {
      return that.countyMap.get(eligSummary.COUNTY + '');
    }
  }

  getABAMonths(params) {
    const eligSummary: EligSummary = params.data;
    const that = params.context.component;


    if (that.isUniverse) {
      return 0;
    } else {
      return eligSummary.ABA_MONTHS;
    }
  }

  // load(request) {
  //   this.http.post<EligibilitySummary>(this.ServerConstants.COMMON_SERVER_API_URL + '/eligsummary/load', request).subscribe(
  //     (data: any) => {
  //       if (data.hasOwnProperty('errorCode')) {
  //         this.notificationService.error('Eligibility Summary', this.userActionNotificationsMap.ERROR);
  //       } else {
  //         if (data != null && data.eligSummaryList != null && data.etEnrollment != null) {
  //           this.eligSummaryList = data.eligSummaryList;
  //           this.etEnrollment = data.etEnrollment;
  //         } else {
  //           this.eligSummaryList = [];
  //           this.etEnrollment = {};
  //           this.noData = true;
  //         }
  //       }
  //     }, response => {
  //       this.error = true;
  //       this.notificationService.error('Eligibility Summary', this.userActionNotificationsMap.ERROR);
  //     }, () => {
  //       this.error = false;
  //     });
  // }

  load() {

    this.http.get<EligSummary[]>(this.ServerConstants.SERVER_API_URL + '/SNAPWorks/GetEligibilitySummary/' + this.ssnValue).subscribe(
      (data: EligSummary[]) => {
        if (data !== null && data !== undefined && data.length > 0) {
          this.eligSummaryList = data;
          this.eligSummaryList.forEach(rows => {
            rows.CERT_BEGIN_DT = this.dateUtil.formatDate( rows.CERT_BEGIN_DT);
            rows.CERT_END_DT = this.dateUtil.formatDate( rows.CERT_END_DT);
          });

        } else {
          this.notificationService.warn('Universe Search', 'Eligibility Summary Information not found in Eligibility System');
          this.eligSummaryList = [];
        }
      },
      response => {
        this.notificationService.error('Universe Search', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
    }

    loadFromAries(emciId) {

      this.http.get(this.ServerConstants.SERVER_API_URL + '/SNAPWorks/Aries/eligInfo/' + emciId).subscribe(
        (data: Array<Object>) => {
          if(data[0]["indvId"]){
            let elgList=[];
            data.forEach((element)=>{
              let record = {
                PROGRAM_CD:null,
                BENEFIT_AMT:null,
                CERT_BEGIN_DT:null,
                CERT_END_DT:null,
                COUNTY:null,
                ABA_MONTHS:null
              }
                record.PROGRAM_CD = element["progCd"];
              record.ABA_MONTHS = element["totalMonthsUsed"];
              if(element["certBegDt"] != null ||  element["certEndDt"] != null){
                // Ticket 49102 - Fixing the format to dates MM/DD/YYYY - MM/DD/YYYY
                record.CERT_BEGIN_DT = this.datePipe.transform(new Date(data[0]["certBegDt"]), 'yyyy/MM/dd');
                record.CERT_END_DT = this.datePipe.transform(new Date(data[0]["certEndDt"]), 'yyyy/MM/dd');
                //record.certificationDates = certStartDt + ' - '+ certEndDt;
              }
              if(element["benefitAmt"] != null){
                record.BENEFIT_AMT = element["benefitAmt"];
              }
              record.COUNTY = element["countyCd"];
              elgList.push(record);
            });
            this.eligSummaryList = elgList;
          }
          else {
            this.notificationService.warn('Universe Search', 'Eligibility Summary Information not found in Eligibility System');
            this.eligSummaryList = [];
          }
        },
        response => {
          this.notificationService.error('Universe Search', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  
  
    }

  parseRefTableData() {
    this.programArray = this.data.getValueFromSharedDataMap('PROGRAMS');
    this.programMap = this.commonUtil.createMapFromList(this.programArray);
    this.programJson = this.commonUtil.createNativeMapFromList(this.programArray);
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
    this.countyArray = this.data.getValueFromSharedDataMap('COUNTIES');
    this.countyMap = this.commonUtil.createMapFromList(this.countyArray);
    this.countyJson = this.commonUtil.createNativeMapFromList(this.countyArray);
  }

  convertCode(myMap, code) {
    if (myMap !== undefined && code !== undefined) {
      return myMap.get(code.toString());
    }
  }

  onGridReady(params) {
    this.gridOptions.api = params.api;
    this.gridApi = params.api;
    this.gridOptions.api.hideOverlay();
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      this.gridOptions.columnDefs = this.columnDefs;
    } else {
      this.gridOptions.api.sizeColumnsToFit();
    }
  }

  focusSummary(e: KeyboardEvent) {
    this.firstTime = false;
    this.addEventListenerToSearch(event);
  }

  addEventListenerToSearch(event){
    const tabKeyCode = 9;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode) {
      return;
    }

    if ( this.eligSummaryList.length === 0 ) {
      return;
    }

    if(event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row
    const index = this.gridApi.getFirstDisplayedRow();
    const rowNode = this.gridApi.getDisplayedRowAtIndex(index);
    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');
    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  focusing(event) {
    if ( !event.shiftKey && event.keyCode === 9 ) {
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/eligibility-summary/eligibility-summary.component.ts